module.exports = __webpack_public_path__ + "media/images/whats_app_icon-b046aa55.png";